import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import LoadingSpinner from "./components/LoadingSpinner";
import "./styles/App.css";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/css/bootstrap.min.css";

// Lazy load components for better performance
const Login = lazy(() => import("./pages/Login"));
const EmailVerification = lazy(() => import("./pages/EmailVerification"));
const ResetPassword = lazy(() => import("./pages/ResetPassword"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const Oempartners = lazy(() => import("./pages/OEM Partners/Oempartners"));
const Profile = lazy(() => import("./pages/Profile/Profile"));
const Revenue = lazy(() => import("./pages/Revenue/Revenue"));
const Transaction = lazy(() => import("./pages/Transaction/Transaction"));
const AllCoupon = lazy(() => import("./pages/Coupon/AllCoupon"));
const OemScan = lazy(() => import("./pages/OEMScan/OemScan"));
const Myscan = lazy(() => import("./pages/My Scan/Myscan"));
const NotFound = lazy(() => import("./pages/NotFound"));
const OemUserdetailpage = lazy(() => import("./pages/OEM Partners/common/OemUserdetailpage"));
const OemScanLogs = lazy(() => import("./pages/Oemscanlogs/OemScanLogs"));

function App() {
  // Navigation handlers
  const handleBackToLogin = () => {
    window.location.href = '/login';
  };

  return (
    <>
      <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          {/* Authentication Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/login/verify" element={<EmailVerification />} />
          <Route path="/verify" element={<EmailVerification />} />
          
          {/* Password Reset Routes */}
          <Route 
            path="/reset-password" 
            element={<ResetPassword onBackToLogin={handleBackToLogin} />} 
          />
          
          {/* Protected Routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="oem-partners" element={<Oempartners />} />
            <Route path="profile" element={<Profile />} />
            <Route path="revenue" element={<Revenue />} />
            <Route path="transactions" element={<Transaction/>} />
            <Route path="all-coupons" element={<AllCoupon />} />
            <Route path="OEMScan" element={<OemScan />} />
            <Route path="scan" element={<Myscan />} />
            <Route path='oem-user-details' element={<OemUserdetailpage/>}/>
            <Route path="oem-myscan-list" element={<OemScanLogs />} />
          </Route>
          
          {/* 404 Route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        style={{ width: "320px" }}
        toastStyle={{ paddingRight: "40px" }}
      />
    </>
  );
}

export default App;